import "./App.css";
import Mainpage from "../src/components/Login/mainpage";
import { MsalProvider } from "@azure/msal-react";
import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { AccessTockenReducer, loginReducer } from "./Redux/store";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

const App = ({ instance }) => {
  //Popup style
  const style = {
    position: "absolute",
    top: "94%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "45%",
    height: 50,
    bgcolor: "background.paper",
    borderRadius: "5px",
    boxShadow: 24,
  };

  //Redux
  const dispatch = useDispatch();
  const isLogin = useSelector((state) => state.Login.isLogin);
  const refresh_token = useSelector((state) => state.AccessTocken.refreshTocken);
  const token = useSelector((state) => state.AccessTocken.accessTocken);
  const timeOut = useSelector((state) => state.AccessTocken.timeOut);

  //Popup boolen
  const [timerPopUp, setTimerPopUp] = useState(false);

  //Calicating Min related variables.
  let Diff = null;
  let Sec = null;
  let min = null;
  let StartSession = 0;

  //API headers
  let options = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  //Second setInterval which checks the checkMin fun
  let Interval;

  //Interval function
  function IntervalFun() {
    Interval = setInterval(() => checkMin(), 30000);
  }

  // Starts first setInterval when page got loaded
  useEffect(() => {
    if (isLogin === true) {
      IntervalFun();
    }
  });

  // Calculates the min to expire the session.
  // const cal = () => {
  //   let presentTime = new Date();
  //   let expireTime = new Date(timeOut);
  //   let d = Math.abs(expireTime - presentTime);
  //   Diff = d;
  //   let s = Diff / 1000;
  //   Sec = s;
  //   let m = Math.floor(Sec / 60);
  //   min = m;
  //   console.log({ d, s, m, Diff, Sec, min, timeOut, presentTime });
  // };
  const cal = () => {
    let presentTime = new Date();
    
    // Parse the timeOut string as UTC, then convert to local time
    let expireTime = new Date(timeOut + 'Z');
    
    let d = Math.abs(expireTime - presentTime);
    Diff = d;
    let s = Diff / 1000;
    Sec = s;
    let m = Math.floor(Sec / 60);
    min = m;
    // console.log({ d, s, m, Diff, Sec, min, timeOut, presentTime, expireTime });
  };

  //If min is less than 4 shows a popup , if the min is less than 1 calls logout api.
  function checkMin() {
    // console.log(isLogin, "IsLogin");
    if (isLogin === true) {
      cal();
      StartSession = 1;
      if (StartSession < 1) {
        IntervalFun();
      }
      if (min < 3) {
        setTimerPopUp(true);
        if (min < 1) {
          logOut();
        }
      }
    } else if (isLogin === false) {
      // console.log("Please login!");
    }
  }

  //Refresh token api used to generate Accesstoken api.
  // const refresh = async () => {
  //   await axios
  //     .post(
  //       "auth/refresh",
  //       {
  //         refreshToken: refresh_token,
  //       },
  //       {
  //         headers: { "content-type": "application/json" },
  //       }
  //     )
  //     .then((response) => {
  //       if (response.status === 200) {
  //         // setMin(10);
  //         setTimerPopUp(false);
  //         sessionStorage.setItem("access_token", response.data.access_token);
  //         dispatch(
  //           AccessTockenReducer.accessTocken(response.data.access_token)
  //         );
  //         sessionStorage.setItem("timeOut", response.data.tokenExpiresAt);
  //         dispatch(AccessTockenReducer.timeOut(response.data.tokenExpiresAt));
  //         window.location.reload();
  //         // clearInterval(Interval); //Terminate the exesting interval.
  //         // IntervalFun(); //Start the new interval.
  //       } else if (response.status !== 200) {
  //         // console.log("Api calling failed");
  //         // sessionStorage.clear();
  //         // window.location.reload();
  //       }
  //     })
  //     .catch((err) => {
  //       // console.log("Api calling failed");
  //       sessionStorage.clear();
  //       window.location.reload();
  //     });
  // };
  const refresh = async () => {
    await axios
      .post(
        "auth/refresh",
        {
          refreshToken: refresh_token,
        },
        {
          headers: { "content-type": "application/json" },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          setTimerPopUp(false);
          sessionStorage.setItem("access_token", response.data.access_token);
          dispatch(
            AccessTockenReducer.accessTocken(response.data.access_token)
          );
  
          // Store the UTC time directly
          sessionStorage.setItem("timeOut", response.data.tokenExpiresAt);
          dispatch(AccessTockenReducer.timeOut(response.data.tokenExpiresAt));
  
          window.location.reload();
        } else if (response.status !== 200) {
          // Handle non-200 status
        }
      })
      .catch((err) => {
        sessionStorage.clear();
        window.location.reload();
      });
  };

  //Logout api function called when clicked on logout button or will be called when the min is less than 1.
  const logOut = async () => {
    await axios
      .post(
        "auth/logout",
        { accessToken: token, refreshToken: refresh_token },
        options
      )
      .then((response) => {
        if (response.status === 200) {
          setTimerPopUp(false);
          // dispatch(loginReducer.Logout());
          dispatch(loginReducer.LoginStatus(false));
          dispatch(AccessTockenReducer.accessTocken(""));
          dispatch(AccessTockenReducer.refreshTocken(""));
          Diff = null;
          Sec = null;
          min = null;
          StartSession = 0;
          clearInterval(Interval); //Clear the interval
          sessionStorage.clear();
          window.location.reload();
        } else if (response.status !== 200) {
          // setTimerPopUp(false);
          // sessionStorage.clear();
          // window.location.reload();
        }
      })
      .catch((err) => {
        sessionStorage.clear();
        window.location.reload();
      });
  };

  return (
    <React.StrictMode>
      <div className="App">
        <MsalProvider instance={instance}>
          <div
          // onClick={() => (isLogin === true && min < 3 ? refresh() : null)}
          // onMouseMove={() => isLogin === true && f()}
          >
            <Mainpage />
          </div>
        </MsalProvider>
        <Modal
          // open={true}
          open={isLogin === true ? timerPopUp : false}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <div className="p-2 d-flex flex-row align-items-center justify-content-evenly">
              <span className="pt-1 text-black">
                <strong>
                  Session is going to expire. Do you want to continue?
                </strong>
              </span>
              <button
                className="btn"
                type="button"
                style={{
                  backgroundColor: "var(--themes-color)",
                  color: "white",
                  minWidth: "80px",
                  borderRadius: "5px",
                  border: "none",
                  fontSize: "15px",
                  padding: "5px",
                }}
                onClick={() => refresh()}
              >
                Continue
              </button>
              <button
                className="btn ms-2"
                type="button"
                style={{
                  backgroundColor: "red",
                  color: "white",
                  minWidth: "80px",
                  borderRadius: "5px",
                  border: "none",
                  fontSize: "15px",
                  padding: "5px",
                }}
                onClick={() => logOut()}
              >
                Log out
              </button>
            </div>
          </Box>
        </Modal>
      </div>
    </React.StrictMode>
  );
};

export default App;
